/**
 * @file magazine-category.schema.ts
 * @description Define o schema Zod para as categorias de seções da revista,
 * permitindo categorias dinâmicas gerenciadas pelo usuário.
 */

import { z } from 'zod';

// --- Schema Principal ---

const MagazineCategorySchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1, 'Nome da categoria é obrigatório').max(100, 'Nome não pode exceder 100 caracteres'),
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date().nullable(),
  createdBy: z.string(),
});

// --- Schemas para DTOs ---

const CreateMagazineCategorySchema = MagazineCategorySchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
}).extend({
  name: z.string().min(1, 'Nome da categoria é obrigatório').max(100, 'Nome não pode exceder 100 caracteres').trim(),
});

const UpdateMagazineCategorySchema = CreateMagazineCategorySchema.partial().extend({
  name: z.string().min(1, 'Nome da categoria é obrigatório').max(100, 'Nome não pode exceder 100 caracteres').trim().optional(),
});

// --- Inferred TypeScript Types ---

type MagazineCategory = z.infer<typeof MagazineCategorySchema>;
type CreateMagazineCategoryDto = z.infer<typeof CreateMagazineCategorySchema>;
type UpdateMagazineCategoryDto = z.infer<typeof UpdateMagazineCategorySchema>;

// --- Public Exports ---

export { 
  MagazineCategorySchema, 
  CreateMagazineCategorySchema, 
  UpdateMagazineCategorySchema 
};
export type { 
  MagazineCategory, 
  CreateMagazineCategoryDto, 
  UpdateMagazineCategoryDto 
};
